import { Injectable } from '@angular/core';
import { distinctUntilChanged, filter, map, Observable, shareReplay } from 'rxjs';
import { CustomClaims } from '../../shared/models/custom-claims';
import { User } from '@angular/fire/auth';
import { idTokenResult } from '@angular/fire/auth-guard';
import { AuthService } from '../authentication/auth';

@Injectable({
  	providedIn: 'root'
})

export class PermissionService {
	private currentUserClaims$: Observable<CustomClaims>;

  	constructor(private authService: AuthService) {
		this.currentUserClaims$ = idTokenResult(this.authService.user$.pipe(filter((u): u is User => !!u))).pipe(map(idToken => {
            const claims = idToken?.claims as CustomClaims || {};

			console.log('Custom Claims para el usuario:', claims);

            console.log('Permisos específicos:', claims.permissions);

            return claims;
        }), distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)), shareReplay(1));
	}

	get userClaims$(): Observable<CustomClaims> {
		return this.currentUserClaims$;
	}

	hasRole(roleName: string): Observable<boolean> {
		return this.currentUserClaims$.pipe(map(claims => claims.roles ? claims.roles.includes(roleName) : false), distinctUntilChanged());
	}

	private _checkSinglePermission(userPermissions: string[], requiredPermission: string): boolean {
        if(userPermissions.includes(requiredPermission)) {
            return true;
        }

        if (requiredPermission.includes('.')) {
            const [resource] = requiredPermission.split('.');
		
            if(userPermissions.includes(`${resource}.*`)) {
                return true;
            }
        }

        return false;
    }

	hasPermission(requiredPermission: string): Observable<boolean> {
		return this.currentUserClaims$.pipe(map(claims => {
			const permissions = claims.permissions || [];
			
			if(permissions.includes('*.*')) {
				return true;
			}

			return this._checkSinglePermission(permissions, requiredPermission);
		}), distinctUntilChanged());
	}

	hasAnyRole(roleNames: string[]): Observable<boolean> {
		return this.currentUserClaims$.pipe(map(claims => {
			const userRoles = claims.roles || [];
			return roleNames.some(role => userRoles.includes(role));
		}), distinctUntilChanged());
	}

	hasAnyPermission(requiredPermissions: string[]): Observable<boolean> {
		return this.currentUserClaims$.pipe(map(claims => {
			const permissions = claims.permissions || [];

			if(permissions.includes('*.*')) {
				return true;
			}

			return requiredPermissions.some(reqPerm => this._checkSinglePermission(permissions, reqPerm));
		}), distinctUntilChanged());
	}

	hasAllPermissions(requiredPermissions: string[]): Observable<boolean> {
		return this.currentUserClaims$.pipe(map(claims => {
			const permissions = claims.permissions || [];

			if(permissions.includes('*.*')) {
				return true;
			}

			return requiredPermissions.every(reqPerm => this._checkSinglePermission(permissions, reqPerm));
		}), distinctUntilChanged());
	}
}